var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BackrsFilledDropShadow from '@backrs_ui/common-ui/src/assets/images/backrs-filled-drop-shadow.svg';
import { ICON_SIZES } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Box } from '@mui/material';
import { BadgeIcon } from './BadgeIcon';
import { BASE_NUGGET_IMAGE_MAX_HEIGHT } from './BaseNugget';
import { HoverButton } from './HoverButton';
import { SponsorChip } from './SponsorChip';
var ToolImage = function (_a) {
    var imageUrl = _a.imageUrl;
    return (_jsx(Box, { component: "img", src: imageUrl || BackrsFilledDropShadow, alt: "Tool", sx: toolImageSx }));
};
var badgeIconConfig = {
    opportunity: {
        backgroundColor: 'Warning/400',
        icon: 'Briefcase01',
    },
    'video-internal': {
        backgroundColor: undefined,
        icon: 'VideoRecorder',
    },
    'video-external': {
        backgroundColor: undefined,
        icon: 'VideoRecorder',
    },
    article: {
        backgroundColor: undefined,
        icon: 'File06',
    },
    institution: {
        backgroundColor: undefined,
        icon: 'Bank',
    },
    employer: {
        backgroundColor: undefined,
        icon: 'Building01',
    },
    audio: {
        backgroundColor: undefined,
        icon: 'VolumeMin',
    },
    document: {
        backgroundColor: undefined,
        icon: 'File02',
    },
    resource: {
        backgroundColor: undefined,
        icon: 'BookOpen01',
    },
    'text-response': {
        backgroundColor: undefined,
        icon: 'File02',
    },
    book: {
        backgroundColor: undefined,
        icon: 'BookOpen01',
    },
    scholarships: {
        backgroundColor: 'Success/500',
        icon: 'CurrencyDollarCircle',
    },
    internship: {
        backgroundColor: 'Warning/400',
        icon: 'Briefcase01',
    },
    'generated-content': {
        backgroundColor: undefined,
        icon: 'File02',
    },
    'career-path': {
        backgroundColor: 'Brand/500',
        icon: 'Palette',
    },
    competency: {
        backgroundColor: 'Brand/200',
        icon: 'BookOpen01',
    },
    'career-track': {
        backgroundColor: 'Brand/500',
        iconColor: 'Colors/Base/White',
        icon: 'Route',
    },
    major: {
        backgroundColor: 'Error/400',
        icon: 'Stand',
    },
    industry: {
        backgroundColor: 'Brand/700',
        icon: 'ShieldDollar',
        iconColor: 'Colors/Base/White',
    },
};
var toolImageSx = {
    width: ICON_SIZES['96px'],
    height: ICON_SIZES['96px'],
    objectFit: 'cover',
};
export var NoPreviewHeader = function (_a) {
    var _b, _c;
    var variant = _a.variant, actionParams = _a.actionParams, isHovered = _a.isHovered, sponsorChipProps = _a.sponsorChipProps, customBadgeIcon = _a.customBadgeIcon;
    var badgeConfig = badgeIconConfig[variant.type];
    var isToolVariant = variant.type === 'tool';
    var toolImageUrl = isToolVariant ? (_c = (_b = variant.toolInfo) === null || _b === void 0 ? void 0 : _b.media) === null || _c === void 0 ? void 0 : _c.media_url : undefined;
    return (_jsxs(Box, { sx: containerSx, children: [_jsxs(Box, { sx: badgeContainerSx, children: [isToolVariant ? (_jsx(ToolImage, { imageUrl: toolImageUrl })) : badgeConfig || customBadgeIcon ? (_jsx(BadgeIcon, __assign({}, (customBadgeIcon || badgeConfig)))) : null, actionParams && (_jsx(HoverButton, { hasBookmarked: actionParams === null || actionParams === void 0 ? void 0 : actionParams.hasBookmarked, handleActionBookmark: actionParams === null || actionParams === void 0 ? void 0 : actionParams.handleActionBookmark, handleActionAddTask: actionParams === null || actionParams === void 0 ? void 0 : actionParams.handleActionAddTask, handleActionShare: actionParams === null || actionParams === void 0 ? void 0 : actionParams.handleActionShare, isVisible: isHovered, isAbsolutelyPositioned: true, position: "flush" }))] }), sponsorChipProps && (_jsx(Box, { sx: sponsorChipOverlaySx, children: sponsorChipProps.map(function (sponsor) { return (_jsx(SponsorChip, { label: sponsor.label, iconImage: sponsor.iconImage, defaultIcon: sponsor.defaultIcon }, sponsor.label)); }) }))] }));
};
var badgeContainerSx = {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
};
var containerSx = function (_a) {
    var backrs = _a.backrs;
    return ({
        position: 'relative',
        width: '100%',
        aspectRatio: '16/9',
        maxHeight: BASE_NUGGET_IMAGE_MAX_HEIGHT,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexDirection: 'column',
        marginBottom: backrs.spacing['spacing-sm'],
    });
};
var sponsorChipOverlaySx = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        columnGap: backrs.spacing['spacing-md'],
        flexDirection: 'row',
        flexWrap: 'wrap',
        rowGap: backrs.spacing['spacing-xs'],
        zIndex: 1,
    });
};
